import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-news-feed',
  templateUrl: './news-feed.component.html',
    styleUrls: ['./news-feed.component.scss']
    
})
export class NewsFeedComponent implements OnInit, AfterViewInit {

    

    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router,
        private authentication: AuthenticationService,
        private common: CommonService) {
    }

    pagecode: string = "news-feed";
    module: string = "home";
    accessdenied: boolean = false;

    userData: any = this.authentication.userData;

    ngAfterViewInit() {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {
                        this.accessdenied = false;

                        var pageURL = this.router.routerState.snapshot.url;
                        debugger;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data

                        //

                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });
    }

    ngOnInit() {

        

    }

}

